import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useDelServerMutation } from '../RTK/ApiRequests'

const LocalServer = ({ isEdit, serverInfo, index, editServer }) => {

  const [DelServer] = useDelServerMutation();
  const [status, setStatus] = useState({});

  const handleDelete = async(id) => {
    const res = await DelServer({serverID: id})

    if(!res.error) {
      window.location.reload();
    }else {
      alert(!res.error.data.message)
    }
  }


  const handleCopy = () => {
    const textToCopy = serverInfo?.ip; 
    navigator.clipboard.writeText(textToCopy) 
      .then(() => {
        console.log('Text copied to clipboard:', textToCopy);
      })
      .catch((error) => {
        console.error('Error copying text:', error);
      });
  }

  const getStatus = async () => {
    await fetch('https://api.mcstatus.io/v2/status/java/' + serverInfo?.ip + ':' + serverInfo?.serverPort).then((response) => {
      return response.json()
    }).then((data) => {
      setStatus(data);
    }).catch((err) => {
      console.log(err)
    })
}

useEffect(() => {
  getStatus();
}, [])



  return (
    <ServerWrapper>
      <div className="list">
        <span>{index}</span>
      </div>
      <div className="info">
        <NavLink to={'/server/?serverId=' + serverInfo?.serverID}>{serverInfo?.serverName}</NavLink>
      </div>
      <div className="banner">
        <NavLink to={'/server/?serverId=' + serverInfo?.serverID}>
          <img src={serverInfo?.bannerImg} alt="bannerGif" />
        </NavLink>
          <div className="ip">
            <span>{serverInfo?.ip}</span>
            <button id='copyElem' onClick={handleCopy}>Copy</button>
          </div>
      </div>
      <div className="status-info">
        <div className="players">
          <span>Players</span>
          <h3>{!status?.online ? '--/--' : status?.players?.online + '/' + status?.players?.max}</h3>
        </div>
        <div className="status">
          <span>Status</span>
          {
            !status?.online ? <h3 style={{color: 'red'}}>Offline</h3> : <h3 style={{color: 'green'}}>Online</h3>
          }
        </div>
      </div>
      {
        isEdit ? <div className="edit-info">
          <div className="edit">
            <span onClick={() => {
              editServer(serverInfo)
            }}>Edit</span>
          </div>
          <div className="delete">
          <span onClick={() => {
              handleDelete(serverInfo?.serverID)
            }}>Delete</span>
          </div>
        </div> : null
      }
    </ServerWrapper>
  )
}

const ServerWrapper = styled.section`
width: fit-content;
border: 2px solid #E2E4E8;
display: flex;
flex-direction: row;
background-color: #fff;
box-shadow: 1px 1px 8px 2px #959191;

.list {
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #E2E4E8;
  padding: 0 8rem;

  span {
    background-color: #58678C;
    padding: 1rem 2rem;
    color: #fff;
    font-size: 2rem;
    border-radius: 5px;
  }
}

.info {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  border-right: 1px solid #E2E4E8;
  padding: 0 8rem;

  a {
    color: #000;
  }
}

.banner {
  padding: 2rem;  
  display: flex;
  flex-direction: column;
  align-items: center;


  .ip {
    display: flex;
    justify-content: space-around;
    width: 100%;

    span {
      display: flex;
      justify-content: space-between;
      background-color: #58678C;
      color: #fff;
      align-items: center;
      font-size: 1.5rem;
      padding: 2px;  
      width: 100%;
    }
    
    #copyElem {
      background-color: #7B8BB9;
      text-transform: uppercase;
      text-align: center;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      padding: 0 2rem;
      outline: none;
      border: none;
    }
  }
}

  .status-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-left: 1px solid #E2E4E8;
    padding: 1rem;
    width: 20%;
    gap: 0rem;

    .players {
      height: 50%;
      border-bottom: 1px solid #E2E4E8;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;

      span {
        font-size: 1.3rem;
      }

      h3 {
        font-weight: 500;
      }
    } 

    .status {
      height: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;

      span {
        font-size: 1.3rem;
      }

      h3 {
        font-weight: 500;
      }
    }
  }

  .edit-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-left: 1px solid #3BA61C;
    padding: 1rem;
    width: 20%;
    gap: 0rem;

    .edit {
      height: 50%;
      border-bottom: 1px solid #3BA61C;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;

      span {
          padding: 1rem 2rem;
          background-color: #58678C;
          color: #fff;
          font-size: 2rem;
          border-radius: 5px;
          cursor: pointer;
      }
    } 

    .delete {
      height: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;

      span {
          padding: 1rem 2rem;
          background-color: #dc2e2e;
          color: #fff;
          font-size: 2rem;
          border-radius: 5px;
          cursor: pointer;
      }
    }
  }

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    width: 90%;
    flex-direction: column;
    align-items: center;

    .list {
      width: 100%;
      border: none;
      border-bottom: 1px solid #3BA61C;
      padding: 1rem 0;
    }

    .info {
      width: 100%;
      border: none;
      padding: 1rem 0;
      border-bottom: 1px solid #3BA61C;
    }

    .banner {
      border-bottom: 1px solid #3BA61C;

      a {
        img {
          width: 100%;
        }
      }
    }

    .status-info {
      flex-direction: row;
      justify-content: center;
      width: 100%;
      border: none;
      border-bottom: 1px solid #3BA61C;
  
      .players {
        border: none;
        border-right: 1px solid #3BA61C;
        padding-right: 5rem;
      } 

      .status {
        padding-left: 5rem;
      }
    }  

    .edit-info {
      border: none;
      flex-direction: row;
      justify-content: space-around;
      width: 100%;

      .edit {
        border: none;
      }
    }
  }

`;

export default LocalServer